import gql from 'graphql-tag';
import React from 'react';
import { compose, graphql } from 'react-apollo';
import { Icon, Label } from 'semantic-ui-react';

const AssigneeIdLabel = ({ user, userId, onFilterDelete }) => (
  <Label key={userId} style={{ marginBottom: '3px' }}>
    {(user && `${user.name} ${user.surname}`) || userId}
    <Icon onClick={onFilterDelete.bind(this, userId, 'assigneeIds')} name="delete" />
  </Label>
);

const User = gql`
  query User($id: ID!) {
    user(id: $id) {
      id
      name
      surname
    }
  }
`;

export default compose(
  graphql(User, {
    skip: ({ userId }) => !userId,
    options: ({ userId }) => ({
      variables: {
        id: userId,
      },
      fetchPolicy: 'cache-first',
    }),
    props: ({ data: { user } }) => {
      return { user };
    },
  })
)(AssigneeIdLabel);



// WEBPACK FOOTER //
// ./src/component/TasksListComponents/AssigneeFilter/IdLabel.js